import { render, staticRenderFns } from "./Enderecos.vue?vue&type=template&id=af0f7478&"
import script from "./Enderecos.vue?vue&type=script&lang=js&"
export * from "./Enderecos.vue?vue&type=script&lang=js&"
import style0 from "./Enderecos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports